"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const selector = [
    'input:not([disabled])',
    'textarea:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([disabled])',
    'a[href]',
    'button:not([disabled])',
    'object',
].join(', ');
exports.default = (node) => {
    const children = [...node.querySelectorAll(selector)];
    // ensure they are all in the dom
    return children.filter((child) => child.offsetParent);
};
